import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { SPORT_IDS } from '../constants/defaultValues';

const GOAL_BADGE_DURATIONS = {
    [SPORT_IDS.soccer]: 30_000,
    [SPORT_IDS.eSoccer]: 10_000,
};

const useGoalBadge = score => {
    const currentScore = useRef(score);
    const [showGoalBadge, setShowGoalBadge] = useState(false);

    const { sportRefId } = useSelector(state => state.sportEvents);

    const badgeTimeout = useRef(null);

    useEffect(() => {
        const goalBadgeDuration = GOAL_BADGE_DURATIONS[sportRefId];

        if (goalBadgeDuration === undefined) return;

        if (score != null && currentScore.current != null && score > currentScore.current) {
            if (badgeTimeout.current != null) {
                clearTimeout(badgeTimeout.current);
            }

            currentScore.current = score;
            setShowGoalBadge(true);

            badgeTimeout.current = setTimeout(() => {
                setShowGoalBadge(false);
            }, goalBadgeDuration);
        } else if (score !== currentScore.current) {
            currentScore.current = score;
        }
    }, [score]);

    useEffect(() => {
        return () => {
            if (badgeTimeout.current != null) {
                clearTimeout(badgeTimeout.current);
            }
        };
    }, []);

    return showGoalBadge;
};

export default useGoalBadge;
